export default "__VITE_ASSET__B4Cnjv$u__"